import { createSlice } from "@reduxjs/toolkit";

const trackauthState = {
  datatrackauth: {},
};

export const trackauthSlice = createSlice({
  name: "trackauth",
  initialState: trackauthState,
  reducers: {
    StoreTrackAuth: (state, actions) => {
      state.datatrackauth = actions.payload;
    },

    ResetTrackAuth: () => trackauthState,
  },
});

export const { StoreTrackAuth, ResetTrackAuth } = trackauthSlice.actions;

export default trackauthSlice.reducer;
